module.exports = __webpack_public_path__ + "img/27.c54246fe.jpg";